<template>
  <div class="boox-list-page">
    <div class="global-header-wrap">
      <div class="left-part">
        <span
          class="tab-btn"
          @click="toggleTab('soft', $event)"
          :class="{ active: tabName === 'soft' }"
          >{{ $t("boox.title3") }}</span
        >
        <span
          class="tab-btn"
          @click="toggleTab('apk', $event)"
          :class="{ active: tabName === 'apk' }"
          >{{ $t("boox.title4") }}</span
        >
        <span
          class="tab-btn"
          @click="toggleTab('extension', $event)"
          :class="{ active: tabName === 'extension' }"
          >{{ "浏览器扩展管理" }}</span
        >
        <!-- <list-search @listSearchEvn="listSearchEvn"/> -->
      </div>
      <div class="right-part">
        <button
          v-if="tabName === 'apk'"
          class="global-button-style"
          @click="
            $router.push({ name: 'createBoox', query: { tabName: 'apk' } })
          "
        >
          <img src="@/assets/img/cmb_btn_add.png" />{{ $t("commonMsg.new") }}
        </button>
        <button
          v-if="tabName === 'soft'"
          class="global-button-style"
          @click="$router.push({ name: 'addBoox', query: { tabName: 'soft' } })"
        >
          <img src="@/assets/img/cmb_btn_add.png" />{{ $t("commonMsg.new") }}
        </button>
        <button
          v-if="tabName === 'extension'"
          class="global-button-style"
          @click="
            $router.push({
              name: 'createExtension',
              query: { tabName: 'extension' }
            })
          "
        >
          <img src="@/assets/img/cmb_btn_add.png" />{{ $t("commonMsg.new") }}
        </button>
      </div>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div class="global-body-wrap">
        <div class="soft-wrap" v-if="tabName === 'soft'">
          <el-table
            :data="softData"
            :header-cell-style="tableHeaderColor"
            :height="tableHeight"
            style="width: 100%;height: 100%;overflow-y: scroll;"
          >
            <el-table-column
              type="index"
              align="center"
              fixed="left"
              label="序号"
              :key="Math.random()"
              width="50"
            >
              <template slot-scope="scope">
                <span>{{
                  (softParams.page - 1) * softParams.limit + scope.$index + 1
                }}</span>
              </template>
            </el-table-column>

            <el-table-column
              prop="title"
              align="center"
              show-overflow-tooltip
              label="标题"
            >
            </el-table-column>
            <el-table-column prop="updatedAt" align="center" label="日期">
              <template slot-scope="scope">
                <span>{{ scope.row.updatedAt | filterDate }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="updatedAt" align="center" label="发布状态">
              <template slot-scope="scope">
                <span v-if="scope.row.public === 0">未发布</span>
                <span v-if="scope.row.public === 1" class="green">已发布</span>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="管理" align="center">
              <template slot-scope="scope">
                <!--<span @click="toView(scope.row._id)" class="checkDetailsBtn">查看详情</span>-->
                <span @click="toEdit(scope.row._id)" class="checkDetailsBtn"
                  >编辑</span
                >
                <span @click="toPublic(scope.row._id)" class="checkDetailsBtn"
                  >发布</span
                >
                <span @click="toDel(scope.row._id)" class="delBtn">删除</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="apk-wrap" v-if="tabName === 'apk'">
          <AppTable
            :tableProps="tableProps"
            :tableData="tableData"
            :currentPage="apkParams.page"
            :pageSize="apkParams.limit"
            @tableHandle="apkTableHandle"
          />
        </div>

        <div class="apk-wrap" v-if="tabName === 'extension'">
          <AppTable
            :tableProps="tableProps"
            :tableData="tableData"
            :currentPage="extensionParams.page"
            :pageSize="extensionParams.limit"
            @tableHandle="extensionTableHandle"
          />
        </div>
      </div>
      <Pagination
        :pageSize="softParams.limit"
        :total="total"
        @pageNum="pageNum"
        v-if="tabName === 'soft'"
      />
      <Pagination
        :pageSize="apkParams.limit"
        :total="total"
        @pageNum="pageNum"
        v-if="tabName === 'apk'"
      />
      <Pagination
        :pageSize="extensionParams.limit"
        :total="total"
        @pageNum="pageNum"
        v-if="tabName === 'extension'"
      />
      <DelPopup
        @deleteHandle="deleteHandle"
        v-if="delPopup && tabName === 'soft'"
      />
    </el-card>

    <el-dialog
      title="软件详情"
      :visible.sync="centerDialogVisible"
      width="50%"
      center
    >
      <div v-if="booxItem">
        <div class="boox-dialog-item">
          <p>标题</p>
          <p>{{ booxItem.title }}</p>
        </div>
        <div class="boox-dialog-item">
          <p>版本</p>
          <p>{{ booxItem.version }}</p>
        </div>
        <div class="boox-dialog-item" v-if="booxItem.file.url">
          <p>链接</p>
          <p>{{ booxItem.file.url }}</p>
          <div class="down-wrap">
            <span class="down-btn" @click="doCopy(booxItem.file.url)"
              >复制</span
            >
          </div>
        </div>
        <div
          class="boox-dialog-item"
          v-if="booxItem.file.url && tabName === 'apk'"
        >
          <p>二维码</p>
          <div class="qrcode" :id="'qrCode' + booxItem._id"></div>
          <div class="down-wrap">
            <a
              class="down-btn"
              :href="booxItem.file.url"
              :download="booxItem.file.name"
              >下载</a
            >
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DelPopup from "@/components/delPopup";
import AppTable from "@/components/appTable";
import Pagination from "@/components/pagination";
// import listMixin from "@/mixins/list";
import ListSearch from "@/components/listSearch";

import Vue from "vue";
import VueClipboard from "vue-clipboard2";
import QRCode from "qrcodejs2";
Vue.use(VueClipboard);

export default {
  // mixins: [listMixin],
  components: {
    AppTable,
    Pagination,
    DelPopup,
    ListSearch
  },
  computed: {
    delPopup: {
      get: function() {
        return this.$store.state.popup.delPopup;
      },
      set: function(newValue) {
        this.$store.state.popup.delPopup = newValue;
        this.$store.state.popup.appModal = newValue;
      }
    },
    tableProps() {
      let tableProps = [
        {
          prop: "title",
          label: "标题"
        },
        {
          prop: "version",
          label: "版本"
        },
        {
          prop: "updatedAt",
          label: "日期"
        },
        {
          prop: "handle",
          label: this.$t("org.manage"),
          width: 200,
          btn: [
            this.$t("commonMsg.checkDetails"),
            this.$t("commonMsg.edit"),
            this.$t("commonMsg.del")
          ]
        }
      ];
      return tableProps;
    },
    tableHeight() {
      return window.innerHeight - 250;
    }
  },
  created() {
    if (this.$route.query.tabName === "soft") {
      this.tabName = "soft";
      this.getSofts();
    } else if (this.$route.query.tabName === "apk") {
      this.tabName = "apk";
      this.getApkList();
    } else if (this.$route.query.tabName === "extension") {
      this.tabName = "extension";
      this.getCloudFiles();
    } else {
      this.tabName = "soft";
      this.getSofts();
    }
  },
  data() {
    return {
      softData: [],
      tableData: [],
      total: 0,
      extensionParams: {
        limit: 20,
        page: 1,
        sortBy: "updatedAt",
        type: "plugin"
      },
      apkParams: { limit: 20, page: 1, sortBy: "updatedAt" },
      softParams: {
        limit: 20,
        page: 1,
        sortBy: "createdAt",
        version: "appUpdate"
      },
      booxItem: null,
      centerDialogVisible: false,
      tabName: "soft",
      updateId: ""
    };
  },
  methods: {
    doCopy(code) {
      this.$copyText(code).then(
        function(e) {
          console.log(e);
        },
        function(e) {
          console.log(e);
        }
      );
    },
    // 表格操作按钮
    tableHandle(type) {
      if (type === "del") {
        this.$http.delUpdate(this.updateId).then(res => {
          this.updateId = "";
          this.delPopup = false;
          this.elMsg(this.$t("alertMsg.delSuccess"), "success");
          this.getSofts();
        });
      }
    },
    //  确认删除
    deleteHandle() {
      this.$store.commit("windowHandle", "delPopup");
      this.tableHandle("del");
    },
    toEdit(id) {
      this.$router.push({
        name: "addBoox",
        query: { id: id, tabName: this.tabName }
      });
    },
    toDel(id) {
      this.updateId = id;
      this.delPopup = true;
    },
    toPublic(id) {
      this.$http
        .publicUpdate({
          id: id,
          data: { id: id, public: 1, version: "appUpdate" }
        })
        .then(res => {
          this.getSofts();
          this.elMsg(this.$t("alertMsg.publicSuccess"), "success");
        });
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f7f7f7;font-weight: 500;";
      }
    },
    getSofts() {
      this.$http.getUpdateList(this.softParams).then(res => {
        this.softData = res.data.results;
        this.total = res.data.count;
      });
    },
    toggleTab(tabName, ev) {
      this.tabName = tabName;
      this.tableData = [];
      if (tabName === "soft") {
        this.softParams.page = 1;
        this.$router.push({
          name: "booxApp",
          query: {
            tabName: "soft"
          }
        });
        this.getSofts();
      } else if (tabName === "apk") {
        this.apkParams.page = 1;
        this.$router.push({
          name: "booxApp",
          query: {
            tabName: "apk"
          }
        });
        this.getApkList();
      } else {
        this.extensionParams.page = 1;
        this.$router.push({
          name: "booxApp",
          query: {
            tabName: "extension"
          }
        });
        this.getCloudFiles();
      }
    },

    getApkList() {
      this.$http.getBooxApp(this.apkParams).then(res => {
        this.tableData = res.data.results;
        this.total = res.data.count;
      });
    },

    apkTableHandle({ type, data }) {
      // apk管理操作
      if (type === this.$t("commonMsg.del")) {
        this.$http.delApk(data.row._id).then(res => {
          this.updateId = "";
          this.delPopup = false;
          this.elMsg(this.$t("alertMsg.delSuccess"), "success");
          this.getApkList();
        });
      } else if (type === this.$t("commonMsg.edit")) {
        this.edit(data);
      } else if (type === this.$t("commonMsg.checkDetails")) {
        this.toDetails(data);
      }
    },
    edit(data) {
      this.$router.push({
        name: "createBoox",
        query: { id: data.row._id, tabName: this.tabName }
      });
    },
    toDetails(data) {
      this.booxItem = data.row;
      if (data.row.file === undefined) {
        this.booxItem["file"] = {};
        this.booxItem["file"]["name"] = "";
        this.booxItem["file"]["url"] = "";
      }
      this.centerDialogVisible = true;

      setTimeout(() => {
        if (document.getElementById("qrCode" + this.booxItem._id)) {
          document.getElementById("qrCode" + this.booxItem._id).innerHTML = "";
          new QRCode("qrCode" + this.booxItem._id, {
            width: 150, // 设置宽度，单位像素
            height: 150, // 设置高度，单位像素
            text: this.booxItem.file.url // 设置二维码内容或跳转地址
          });
        }
      }, 300);
    },

    getCloudFiles() {
      this.$http.getCloudFiles(this.extensionParams).then(res => {
        this.tableData = res.data.results;
        this.total = res.data.count;
      });
    },

    extensionTableHandle({ type, data }) {
      // apk管理操作
      if (type === this.$t("commonMsg.del")) {
        this.$http.delCloudFiles(data.row._id).then(res => {
          this.updateId = "";
          this.delPopup = false;
          this.elMsg(this.$t("alertMsg.delSuccess"), "success");
          this.getCloudFiles();
        });
      } else if (type === this.$t("commonMsg.edit")) {
        this.editExtension(data);
      } else if (type === this.$t("commonMsg.checkDetails")) {
        this.toExtensionDetails(data);
      }
    },
    editExtension(data) {
      this.$router.push({
        name: "createExtension",
        query: { id: data.row._id, tabName: this.tabName }
      });
    },
    toExtensionDetails(data) {
      this.booxItem = data.row;
      if (data.row.file === undefined) {
        this.booxItem["file"] = {};
        this.booxItem["file"]["name"] = "";
        this.booxItem["file"]["url"] = "";
      }
      this.centerDialogVisible = true;
    },

    pageNum(page) {
      if (this.tabName === "apk") {
        // apk
        this.apkParams.page = page;
        this.getApkList();
      } else if (this.tabName === "extension") {
        // 浏览器扩展
        this.extensionParams.page = page;
        this.getCloudFiles();
      } else {
        // 发布记录
        this.softParams.page = page;
        this.getSofts();
      }
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.boox-list-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .left-part {
    flex: 1;
    display: flex;
    align-items: center;
    .tab-btn {
      cursor: pointer;
      color: #666;
      &.active {
        font-weight: bold;
      }
    }
    > span {
      margin-right: 10px;
      font-size: 16px;
    }
    .global-button-style {
      margin: 0;
    }
  }
  .apk-wrap,
  .soft-wrap {
    flex: 1;
  }
  .boox-dialog-item {
    padding-bottom: 10px;
    line-height: 25px;
    > p:first-child {
      font-weight: bold;
    }
  }
  .green {
    color: #28c328;
  }
  .down-wrap {
    margin-top: 5px;
    .down-btn {
      border: 1px solid #bf735b;
      background-color: #bf735b;
      color: #fff;
      border-radius: 3px;
      padding: 5px 15px;
      cursor: pointer;
      &:hover {
        background-color: #cc8f7c;
      }
    }
  }
}
</style>
